import { render, staticRenderFns } from "./certPDF.vue?vue&type=template&id=630b0564"
import script from "./certPDF.vue?vue&type=script&lang=js"
export * from "./certPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports